<template>
  <div class="home-view">
    <div class="home-view__action">
      <SimpleButton :title="introSettings.button_label" :to="testRoute" large />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Routes } from "@/constants";

import SimpleButton from "@/components/SimpleButton";

export default {
  name: "HomeView",
  data() {
    return {
      testRoute: Routes.quiz.path
    };
  },
  components: {
    SimpleButton
  },
  computed: {
    ...mapState({
      introSettings: state => state.introSettings
    })
  }
};
</script>

<style lang="scss" scoped>
.home-view {
  display: block;

  &__action {
    animation: enterAction 1.2s ease forwards;
    bottom: 10vh;
    left: 50%;
    opacity: 0;
    position: fixed;
    transform: translate(-50%, 10vh);

    @include if-tablet {
      bottom: 100px;
    }

    @keyframes enterAction {
      0% {
        opacity: 0;
        transform: translate(-50%, 10vh);
      }
      100% {
        opacity: 1;
        transform: translate(-50%, 0);
      }
    }
  }
}
</style>
